const brand = {
  name: "Shillong State Lottery",
  shortName: "Shillong Lottery",
  location: "Shillong",
  tagline: "Daily 1 PM and 8 PM lottery results",
  description:
    "Fast, mobile-friendly Shillong State Lottery results with result history, PDF download, and share-ready updates.",
  supportEmail: "cloudcoreconnect@gmail.com",
  whatsappText:
    "Check today's Shillong State Lottery result on the live result desk.",
  telegramUrl: "https://t.me/shillongstatelottery",
  drawTimes: [
    {
      key: "1pm",
      label: "1:00 PM",
      name: "Afternoon Draw",
      releaseHour: 13,
      accent: "#0f9f6e",
    },
    {
      key: "8pm",
      label: "8:00 PM",
      name: "Evening Draw",
      releaseHour: 20,
      accent: "#d89422",
    },
  ],
};

export const getDrawByKey = (key) =>
  brand.drawTimes.find((draw) => draw.key === key) || brand.drawTimes[0];

export default brand;
